import React, { useState } from 'react'
import './styles.scss'
import { config } from './config'

interface Props {
  children: JSX.Element | string
  backgroundColor: string
}

export const Box = ({ children, backgroundColor }: Props) => {
  const [open, setopen] = useState<boolean>(false)

  return (
    <div className={`Box ${open ? 'open' : ''}`} style={{ backgroundColor }}>
      <div className='ui text container'>
        <div className='ta text'>{children}</div>
      </div>

      <button
        className='morewrapper'
        onClick={() => {
          setopen(!open)
        }}
      >
        <div className='gradient' />
        <div className='more' />
      </button>
    </div>
  )
}
